import { Button, DialogActions } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  onCancel?: () => void;
  cancelText?: string;
  cancelDisabled?: boolean;
}

const DialogButtons = ({ onCancel, cancelText, cancelDisabled, children }: PropsWithChildren<Props>) => {
  return (
    <DialogActions sx={{ py: 2, px: 3, columnGap: 1 }}>
      {onCancel && (
        <Button variant="text" color="secondary" autoFocus onClick={onCancel} disabled={cancelDisabled}>
          {cancelText || "Cancel"}
        </Button>
      )}

      {children}
    </DialogActions>
  );
};

export default DialogButtons;
